import { getFocusMerge } from './focusMerge';
export var focusOn = function focusOn(target, focusOptions) {
  target.focus(focusOptions);

  if ('contentWindow' in target && target.contentWindow) {
    target.contentWindow.focus();
  }
};
var guardCount = 0;
var lockDisabled = false;
export var setFocus = function setFocus(topNode, lastNode, options) {
  if (options === void 0) {
    options = {};
  }

  var focusable = getFocusMerge(topNode, lastNode);

  if (lockDisabled) {
    return;
  }

  if (focusable) {
    if (guardCount > 2) {
      console.error('FocusLock: focus-fighting detected. Only one focus management system could be active. ' + 'See https://github.com/theKashey/focus-lock/#focus-fighting');
      lockDisabled = true;
      setTimeout(function () {
        lockDisabled = false;
      }, 1);
      return;
    }

    guardCount++;
    focusOn(focusable.node, options.focusOptions);
    guardCount--;
  }
};